export { default } from "./AdminConsoleFacultyAdderModal";
